import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section className="relative w-full h-screen min-h-[600px] flex items-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=Abstract%20dramatic%20entertainment%20news%20backdrop%20with%20warm%20coral%20orange%20and%20deep%20burgundy%20gradient%2C%20blurred%20paparazzi%20flash%20lights%2C%20cinematic%20red%20carpet%20vibe%2C%20luxurious%20velvet%20texture%2C%20golden%20spotlight%20rays%2C%20editorial%20magazine%20quality%2C%20rich%20atmospheric%20depth%2C%20dramatic%20warm%20lighting%2C%20soft%20bokeh%20highlights%2C%20elegant%20abstract%20composition&width=1800&height=1200&seq=hero-main-bg&orientation=landscape"
        alt="51黑料吃瓜网 - 娱乐爆料平台"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/55 via-black/35 to-black/60"></div>

      <div className="relative z-10 w-full px-4 md:px-6 lg:px-12">
        <div className="max-w-[1400px] mx-auto">
          <div className="max-w-2xl">
            <span className="inline-block px-4 py-1.5 rounded-full border border-white/40 text-white/90 text-xs md:text-sm font-medium mb-4 md:mb-5 whitespace-nowrap">
              <i className="ri-fire-line mr-1.5"></i>
              全网最热爆料平台
            </span>
            <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white leading-tight mb-4 md:mb-6">
              51黑料吃瓜网
              <br />
              <span className="text-primary-300">在线观看与不打烊</span>
            </h1>
            <p className="text-white/70 text-sm md:text-base lg:text-lg max-w-lg mb-8 leading-relaxed">
              汇聚每日黑料大赛独家猛料，实时追踪网红明星最新爆点。
              提供吃瓜视频、黑料不打烊等核心访问方式，7×24小时不间断更新。
            </p>
            <div className="flex flex-col sm:flex-row gap-3">
              <Link
                to="/category/mingxing-bagua"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-primary-500 hover:bg-primary-600 text-white font-semibold text-sm md:text-base transition-all duration-300 whitespace-nowrap"
              >
                <i className="ri-flashlight-line"></i>
                立即吃瓜
                <i className="ri-arrow-right-up-line"></i>
              </Link>
              <Link
                to="/category/wanghong-baoliao"
                className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full border border-white/30 hover:border-white/60 text-white font-medium text-sm md:text-base transition-all duration-300 whitespace-nowrap"
              >
                <i className="ri-play-circle-line"></i>
                观看吃瓜视频
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
        <div className="flex items-center gap-2 text-white/50 text-xs">
          <span>向下滚动探索更多</span>
          <i className="ri-arrow-down-line animate-bounce"></i>
        </div>
      </div>
    </section>
  );
}